<template>
  <div class="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-3">
      <!-- Buscador Rápido -->
      <div class="relative md:col-span-5 lg:col-span-5">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <i class="fa fa-search text-gray-400 text-xs" />
        </div>
        <input 
          v-model="form.search" 
          type="text" 
          class="block w-full pl-9 pr-3 py-2 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 placeholder-gray-400 text-sm transition-colors" 
          placeholder="Buscar por ID, usuario, producto o referencia..."
        />
      </div>

      <!-- Fecha Desde -->
      <div class="md:col-span-2">
        <div class="relative">
          <input 
            v-model="form.date_from" 
            type="date"
            class="block w-full px-3 py-2 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 text-sm text-gray-700"
            title="Fecha Desde"
          />
        </div>
      </div>

      <!-- Fecha Hasta -->
      <div class="md:col-span-2">
        <div class="relative">
          <input 
            v-model="form.date_to" 
            type="date"
            class="block w-full px-3 py-2 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 text-sm text-gray-700"
            title="Fecha Hasta"
          />
        </div>
      </div>

      <!-- Estado -->
      <div class="md:col-span-2">
        <select 
          v-model="form.status"
          class="form-select w-full border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 text-gray-700 bg-white text-sm py-2"
        >
          <option :value="null">Todos los estados</option>
          <option value="request">Solicitud</option>
          <option value="process">Procesado</option>
          <option value="canceled">Anulado</option>
        </select>
      </div>

      <!-- Botón Limpiar Filtros -->
      <div class="md:col-span-1 flex items-center justify-end">
        <button 
          v-if="hasActiveFilters"
          type="button"
          class="w-full py-2 px-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors flex items-center justify-center gap-1 text-sm cursor-pointer" 
          title="Limpiar Filtros"
          @click="resetFilters"
        >
          <i class="fa fa-times" />
          <span class="md:hidden">Limpiar</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'InventoryFilters',

  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['filter', 'reset'],

  data() {
    return {
      form: {
        search: this.filters?.search || '',
        status: this.filters?.status || null,
        date_from: this.filters?.date_from || '',
        date_to: this.filters?.date_to || '',
        report_type: this.filters?.report_type || null,
      },
    }
  },

  computed: {
    hasActiveFilters() {
      return !!(this.form.search || this.form.status || this.form.date_from || this.form.date_to || this.form.report_type)
    },
  },

  watch: {
    filters: {
      deep: true,
      handler(newFilters) {
        if (newFilters) {
          this.form.search = newFilters.search || ''
          this.form.status = newFilters.status || null
          this.form.date_from = newFilters.date_from || ''
          this.form.date_to = newFilters.date_to || ''
          this.form.report_type = newFilters.report_type || null
        }
      },
    },
    form: {
      deep: true,
      handler: debounce(function() {
        this.$emit('filter', { ...this.form })
      }, 350),
    },
  },

  methods: {
    resetFilters() {
      this.form = {
        search: '',
        status: null,
        date_from: '',
        date_to: '',
        report_type: null,
      }
      this.$emit('reset')
    },
  },
}
</script>
